import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/learningPage.js";
import FullWidthImage from "./Sections/FullWidthImage";
import Menu from "./Sections/Menu";
import {
  useParams
} from "react-router-dom";
import Products from "./Sections/Products";
import DocumentInquiry from "./Sections/DocumentInquiry";
import CertificateSample from "./Sections/CertificateSample";
import ScienceCommittee from "./Sections/ScienceCommittee";
import Calander from "./Sections/Calander";
import GridContainer from "components/Grid/GridContainer";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function LearningPage(props) {

  const classes = useStyles();
  const { ...rest } = props;
  let { id } = useParams();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div>
      <Header
        color="transparent"
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 30,
          color: "white"
        }}
        {...rest}
      />
      <Parallax verySmall filter image={require("assets/img/bg17.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <img
                    src={"/assets/images/learning_banner.jpg"}
                    alt="جشنواره رویدادهای آموزشی"
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
          <Menu active={0} />
<GridContainer>
<Grid xs={12} sm={12} md={12}>
{(() => {
        if (!id || id == "All") {
          return (
            <Products tags={['Software','Design','Security','Business','Network','OS','Marketing']}></Products>
          )
        }else if (!id || id == "Software") {
          return (
            <Products tags={['Software']}></Products>
          )
        }else if(id == "Design"){
          return (
            <Products tags={['Design']}></Products>
          )
        }
        else if(id == "Security"){
          return (
            <Products tags={['Security']}></Products>
          )
        }else if(id == "Business"){
          return (
            <Products tags={['Business']}></Products>
          )
        }
        else if(id == "Marketing"){
          return (
            <Products tags={['Marketing']}></Products>
          )
        }
        else if(id == "OS"){
          return (
            <Products tags={['OS']}></Products>
          )
        }
        else if(id == "Network"){
          return (
            <Products tags={['Network']}></Products>
          )
        }
        else if(id == "DocumentInquiry"){
          return (
            <DocumentInquiry ></DocumentInquiry>
          )
        }else if(id == "Certificate"){
          return (
            <CertificateSample ></CertificateSample>
          )
        }else if(id == "ScienceCommittee"){
          return (
            <ScienceCommittee></ScienceCommittee>
          )
        }else if(id == "Calander"){
          return (
            <Calander></Calander>
          )
        }
      })()}
</Grid>

</GridContainer>
     
        </div>
      </div>
      <Footer />
    </div>
  )
}
